import { UseQueryResult, useQuery } from 'react-query';

import { getTokenWithType } from './useAuth';

import { twilioPhoneTypes } from '../utils/urls';

import { ErrorModal } from 'types/modalTypes';

async function fetchPhoneTypes(): Promise<APIResult> {
  const response = await fetch(twilioPhoneTypes, {
    method: 'GET',
    headers: {
      Authorization: getTokenWithType(),
    },
  });
  return response.json();
}

type TError = ErrorModal;

type APIResult = {
  IsSuccess: boolean;
  StatusCode: number;
  Data: Array<{
    Name: string;
    Description: string;
    Id: string;
  }>;
};

type TResult = Array<{
  id: number;
  name: string;
  description: string;
}>;

function useGetTwilioPhoneTypes(): UseQueryResult<TResult, TError> {
  return useQuery(
    'get_twilio_phone_types',
    async () => {
      const fetchResponse = await fetchPhoneTypes();
      const result = fetchResponse?.Data?.map(item => ({
        id: item.Id,
        name: `${item.Name}`,
        description: `${item.Description}`,
      }));
      return result;
    },
    {
      staleTime: 60 * 1000,
      refetchOnWindowFocus: false,
    },
  );
}

export { useGetTwilioPhoneTypes };
